
import { Component, Prop, Vue } from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";
import { mapState } from "vuex";
import Deferrable from "@/libs/common/delegate/Deferrable";
import { Duct } from "@/libs/Duct";
import Defer from "@/libs/Defer";
import MatchInterface from "@/libs/model/MatchInterface";
import MatchInfo from "@/components/Match/MatchInfo.vue";
import groupBy from "lodash/groupBy";
import upperFirst from  "lodash/upperFirst";
import { Dictionary } from "lodash";
import MatchHolder from "@/components/Knockout/MatchHolder.vue";

@Component({
  components: {
     MatchInfo, MatchHolder
  },
  computed: {
    ...mapState({
      worldCupMatches: "worldCupMatches"
    })
  }
})
export default class Knockout
  extends WorldCupComponent
  implements Deferrable {
  config: any;
  worldCupMatches: any;
  isPreloaded: boolean;
  isMounted: boolean;
  defer: Defer;


  get matches(): Array<any>  {
    let list = this.getDataList();
    this.onDebug(this, "Match::getDataList", list);
    let groupList = this.getGroupMatches(list);
    return groupList;
  }

  get dataForKnockout():  any {
    let list = this.matches;
    let dataGroupByWinnerId = {};
    let winnerIdKeys = {};
     const keys = Object.keys(list);
     keys.forEach( key => {
        if(key === "8th Finals" || key === "Quarter-finals" || key === "Semi-finals") {
          var dataGroupedByStage = list[key];
          const tempDataByWinnerId = groupBy(dataGroupedByStage,item => item.matchInfo.nextMatchWinnerId);
          dataGroupByWinnerId[key] = tempDataByWinnerId;
          winnerIdKeys[key] = Object.keys(tempDataByWinnerId);
        }
        if(key === 'Final')  {
          var final= {"finalId":list[key]}
          dataGroupByWinnerId[key] = final;
        }
    })
    if(dataGroupByWinnerId.hasOwnProperty("Final")){
      dataGroupByWinnerId["Final"]["finalId"].push(list["3rd Place Final"][0])
    }
    let swappedData = this.swapProperties(dataGroupByWinnerId);
    let swapWinnerIdList = this.swapArray(winnerIdKeys);
    let orderedList = this.arrangeOrder(swapWinnerIdList,swappedData);
    return orderedList;
  }

  swapArray(data: any): any {
     if(data.hasOwnProperty("8th Finals")) {
        let list = data["8th Finals"];
        if(list.length > 0){
          [list[1],list[2]] = [list[2],list[1]];
        }
        return data;
      }
      return data;
  }

  swapProperties(data:any): any {
    if(data.hasOwnProperty("8th Finals")) {
      let list = data["8th Finals"];
      const keys = Object.keys(list);
      let swappedList = {};
      if(keys.length > 0) {
        [keys[1],keys[2]] = [keys[2],keys[1]] ;
        keys.forEach(key => {
          swappedList[key] = list[key];
        })
      }
      data["8th Finals"] = swappedList;
      return data;
    }
  return data;
  }

  arrangeOrder(winnerIdKeys:any, data:any): any {

    let newKeys = [ "8th Finals", "Quarter-finals"];
    newKeys.forEach( key => {   

      let key2 = "";
      if(key === "8th Finals"){
        key2 = "Quarter-finals";
      }
      if(key ===  "Quarter-finals"){
        key2 = "Semi-finals";
      }
      if(winnerIdKeys.hasOwnProperty(key) && data.hasOwnProperty(key2) && winnerIdKeys.hasOwnProperty(key2)){
        var list1 = winnerIdKeys[key];
        var list2 = data[key2];
        var list3 = winnerIdKeys[key2];
        
        for(var j=0; j< list3.length; j++){
          var list4 = list2[list3[j]];
          var list5 = [];
          for(var i=0; i<list1.length ; i++){
            if(list1[i] === list4[0].matchInfo.id){
              list5.push( list4[0]);
            }
            if(list1[i] === list4[1].matchInfo.id){
              list5.push( list4[1]);
            }
          }
          list2[list3[j]] = list5
        }
        data[key2] = list2;
      }
  })
  return data;
}


  get isEmpty(): boolean {
    let data = this.getStoreData(this.worldCupMatches);

    if (!data) {
      return true;
    }

    if (!data.match) {
      return true;
    }

    if(data.match.length >= 0){
      return false;
    }

    return true;
  }

  getDataList(): Array<MatchInterface> {
    let data = this.getStoreData(this.worldCupMatches);

    if (!data) {
      return [];
    }

    if (!data.match) {
      return [];
    }

    let list = [...data.match];
    list = this.getSortedList(list);

    let show = this.getOption().knockout.show;
    if(show === "all"){
      return list;
    }

    if(show.includes(",")){
      return this.getMixed(list, show);
    } else {
      return this.getFilteredList(list, show);
    }
  }

  get defaultMessageText(): string {
    return this.getOption().knockout.defaultMessage.text;
  }

  get isDefaultMessageHtml(): boolean {
    return this.getOption().knockout.defaultMessage.html;
  }

  /**
   * This is a working sort function. No need to perform sort after the group, once
   * everything is sorted then expect that time is also sorted.
   * ~lem
   * @param list
   */
  getSortedList(list: Array<MatchInterface>){

    let sortOrder = this.getOption().knockout.sortOrder;

    return list.sort((a,b)=>{
      let aDateTime = new Date(`${a.matchInfo.localDate}T${a.matchInfo.localTime}`);
      let bDateTime =new Date(`${b.matchInfo.localDate}T${b.matchInfo.localTime}`);
      if(sortOrder === "asc"){
        return aDateTime.getTime() - bDateTime.getTime();
      }
      if(sortOrder === "dsc"){
        return bDateTime.getTime() - aDateTime.getTime();
      }
      return 0;
    });
  }

  getGroupMatches( data:Array<MatchInterface>): any {
    const matchesGroupedByStage = groupBy(data, item => item.matchInfo.stage.name);
    return matchesGroupedByStage;
  }

  getFilteredList(list: Array<MatchInterface>, status: string){
    let statusName = upperFirst(status);
    return list.filter((match) => {
      if(match.liveData && match.liveData.matchDetails && match.liveData.matchDetails.matchStatus === statusName){
        return match;
      }
    });
  }

  getMixed(list: Array<MatchInterface>, status: string){
    let statuses = status.split(",").map((s)=>{
      return upperFirst(s.trim());
    });
    return list.filter((match) => {
      if(match.liveData && match.liveData.matchDetails){
        let matchStatus = match.liveData.matchDetails.matchStatus;
        if(statuses.includes(matchStatus)){
          return match;
        }
      }
    });
  }

  getdateOfStage(): any {
    return this.getOption().knockout.dateOfStage;
  }


  created() {
    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted(){
    this.isMounted = true;
    this.onDebug(this, "Knockout:mounted", {});
   
  }

  onDefer() {
    if (this.isPreloaded && this.isMounted) {
      return false;
    }
    return true;
  }

  setEighthFinalStage() {
    var firstlist = document.getElementsByClassName("first");
    var secondlist = document.getElementsByClassName("second");
    var thirdlist = document.getElementsByClassName("third");
    var fourthlist = document.getElementsByClassName("fourth");
    var container = document.getElementById('knockout-view');
    for(var l=0; l < firstlist.length; l++ ){
      if(firstlist[l].classList.value.indexOf("quarterFinal") !== -1){
      firstlist[l].classList.remove("quarterFinal");
      }
      if(firstlist[l].classList.value.indexOf("semiFinal") !== -1){
      firstlist[l].classList.remove("semiFinal");
      }
      if(firstlist[l].classList.value.indexOf("final") !== -1){
      firstlist[l].classList.remove("final");
      }
      if(firstlist[l].classList.value.indexOf("eighthFinal") === -1){
      firstlist[l].classList.add("eighthFinal");
      }
    }

    for(var i=0; i < secondlist.length; i++ ){
      if(secondlist[i].classList.value.indexOf("eighthFinal") !== -1){
      secondlist[i].classList.remove("eighthFinal");
      }
      if(secondlist[i].classList.value.indexOf("semiFinal") !== -1){
      secondlist[i].classList.remove("semiFinal");
      }
      if(secondlist[i].classList.value.indexOf("final") !== -1){
      secondlist[i].classList.remove("final");
      }
      if(secondlist[i].classList.value.indexOf("quarterFinal") === -1){
      secondlist[i].classList.add("quarterFinal");
      }
    }
    for(var j=0; j < thirdlist.length; j++){
      if(thirdlist[j].classList.value.indexOf("eighthFinal") !== -1){
        thirdlist[j].classList.remove("eighthFinal");
      }
      if(thirdlist[j].classList.value.indexOf("quarterFinal") !== -1){
        thirdlist[j].classList.remove("quarterFinal");
      }
      if(thirdlist[j].classList.value.indexOf("final") !== -1){
        thirdlist[j].classList.remove("final");
      }

      if(thirdlist[j].classList.value.indexOf("semiFinal") === -1){
        thirdlist[j].classList.add("semiFinal");
      }
    } 
     for(var k=0;k < fourthlist.length; k++){
      if(fourthlist[k].classList.value.indexOf("eighthFinal") === -1){
        fourthlist[k].classList.remove("eighthFinal");
      }
      if(fourthlist[k].classList.value.indexOf("quarterFinal") === -1){
        fourthlist[k].classList.remove("quarterFinal");
      }
      if(fourthlist[k].classList.value.indexOf("semiFinal") === -1){
        fourthlist[k].classList.remove("semiFinal");
      }
      if(fourthlist[k].classList.value.indexOf("final") === -1){
        if(fourthlist[k].classList.value.indexOf("thirdFinal") === -1) {
        fourthlist[k].classList.add("final");
        }
      }
    }
    container.style.height = "1762px";           

  }

  setQuarterFinalStage() {
    var container = document.getElementById('knockout-view');
    var firstlist = document.getElementsByClassName("first");
    var secondlist = document.getElementsByClassName("second");
    var thirdlist = document.getElementsByClassName("third");
    var fourthlist = document.getElementsByClassName("fourth");
    for(var i=0; i < secondlist.length; i++ ){
      if(secondlist[i].classList.value.indexOf("quarterFinal") !== -1){
      secondlist[i].classList.remove("quarterFinal");
      }
      if(secondlist[i].classList.value.indexOf("semiFinal") !== -1){
      secondlist[i].classList.remove("semiFinal");
      }
      if(secondlist[i].classList.value.indexOf("final") !== -1){
      secondlist[i].classList.remove("final");
      }
      if(secondlist[i].classList.value.indexOf("eighthFinal") === -1) {

      secondlist[i].classList.add("eighthFinal");
      }
    }
    for(var j=0; j < thirdlist.length; j++){
      if(thirdlist[j].classList.value.indexOf("eighthFinal") !== -1){
      thirdlist[j].classList.remove("eighthFinal");
      }
      if(thirdlist[j].classList.value.indexOf("semiFinal") !== -1){
      thirdlist[j].classList.remove("semiFinal");
      }
      if(thirdlist[j].classList.value.indexOf("final") !== -1){
      thirdlist[j].classList.remove("final");
      }
      if(thirdlist[j].classList.value.indexOf("quarterFinal") === -1){
      thirdlist[j].classList.add("quarterFinal");
      }
    }
    for(var k=0;k < fourthlist.length; k++){
      if(fourthlist[k].classList.value.indexOf("final") !== -1){
        fourthlist[k].classList.remove("final");
      }
      if(fourthlist[k].classList.value.indexOf("eighthFinal") !== -1){
        fourthlist[k].classList.remove("eighthFinal");
      }
      if(fourthlist[k].classList.value.indexOf("quarterFinal") !== -1){
        fourthlist[k].classList.remove("quarterFinal");
      }
      if(fourthlist[k].classList.value.indexOf("semiFinal") === -1){
        if(fourthlist[k].classList.value.indexOf("thirdFinal") === -1) {
      fourthlist[k].classList.add("semiFinal");
        }
      }
    }
    container.style.height = "902px";

  }

  setSemiFinalStage() {
    var container = document.getElementById('knockout-view');
    var thirdlist = document.getElementsByClassName("third");
    var fourthlist = document.getElementsByClassName("fourth");
    for(var j=0; j < thirdlist.length; j++){
      if(thirdlist[j].classList.value.indexOf("quarterFinal") !== -1){
      thirdlist[j].classList.remove("quarterFinal");
      }
        if(thirdlist[j].classList.value.indexOf("semiFinal") !== -1){
      thirdlist[j].classList.remove("semiFinal");
      }
      if(thirdlist[j].classList.value.indexOf("final") !== -1){
      thirdlist[j].classList.remove("final");
      }
      if(thirdlist[j].classList.value.indexOf("eighthFinal") === -1){
      thirdlist[j].classList.add("eighthFinal");
      }
    }
    for(var k=0;k < fourthlist.length; k++){
      if(fourthlist[k].classList.value.indexOf("semiFinal") !== -1){
        fourthlist[k].classList.remove("semiFinal");
      }
      if(fourthlist[k].classList.value.indexOf("eighthFinal") !== -1){
        fourthlist[k].classList.remove("eighthFinal");
      }
      if(fourthlist[k].classList.value.indexOf("final") !== -1){
        fourthlist[k].classList.remove("final");
      }
      if(fourthlist[k].classList.value.indexOf("quarterFinal") === -1){
        if(fourthlist[k].classList.value.indexOf("thirdFinal") === -1) {
      fourthlist[k].classList.add("quarterFinal");
        }
      }
    }
    container.style.height = "612px";

  }

  setFinalsStage() {
    var container = document.getElementById('knockout-view');
    var fourthlist = document.getElementsByClassName("fourth");
    for(var k=0;k < fourthlist.length; k++){
      if(fourthlist[k].classList.value.indexOf("semiFinal") !== -1){
        fourthlist[k].classList.remove("semiFinal");
      }
      if(fourthlist[k].classList.value.indexOf("quarterFinal") !== -1){
        fourthlist[k].classList.remove("quarterFinal");
      }
      if(fourthlist[k].classList.value.indexOf("final") !== -1){
        fourthlist[k].classList.remove("final");
      }
      if(fourthlist[k].classList.value.indexOf("eighthFinal") === -1){
        if(fourthlist[k].classList.value.indexOf("thirdFinal") === -1) {
      fourthlist[k].classList.add("eighthFinal");
        }
      }
    }
    container.style.height = "512px";

  }



  onReady() {
     var knockoutComponent = this;
    var container = document.getElementById('knockout-view');
    var firstPosition = 0;
    var secondPosition = 240;
    var thirdPosition = 480;
    var fourthPosition = 720;
    var maxScrollLeft = container.scrollWidth - container.clientWidth;
    var btnSlideLeft = document.getElementById("btn-knockout-slide-left");
    var btnSlideRight = document.getElementById("btn-knockout-slide-right");
    btnSlideLeft.classList.add("btn-hide");
    let date = new Date();
    let localDate = new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year: 'numeric'}).format(date);
    switch(localDate){
      case this.getdateOfStage().eighthFinals:
        container.scrollLeft = firstPosition;
        break;
      case this.getdateOfStage().quarterFinals:
        this.setQuarterFinalStage();
        container.scrollLeft = secondPosition;
        break;
      case this.getdateOfStage().semiFinals:
        this.setSemiFinalStage();
         container.scrollLeft = thirdPosition;
         break;
      case this.getdateOfStage().finals:
        this.setFinalsStage();     
       container.scrollLeft = fourthPosition; 
       break;

    }


    $( ".knockout-slide-right" ).each(function() {
      $(this).on('click', function() {
      var container = document.getElementById('knockout-view');
      var remainingScroll;
      remainingScroll = maxScrollLeft - container.scrollLeft;
      switch(true) {
        case (container.scrollLeft >= firstPosition && container.scrollLeft < secondPosition):
          {
           if(remainingScroll >= 240) {
             knockoutComponent.setQuarterFinalStage();
           }
          container.scrollLeft = secondPosition;
          break;
        }
        case  (container.scrollLeft >= secondPosition && container.scrollLeft < thirdPosition):
          {
             if(remainingScroll >= 240) {       
               knockoutComponent.setSemiFinalStage();
             }
            container.scrollLeft = thirdPosition;
           break;
          }
        case  (container.scrollLeft >= thirdPosition && container.scrollLeft < fourthPosition):
          {
            remainingScroll = maxScrollLeft - container.scrollLeft;
            if(remainingScroll >= 240) {
               knockoutComponent.setFinalsStage();
            }
            container.scrollLeft = fourthPosition;
           break;
          }
        case (container.scrollLeft === fourthPosition):
            break;

      }
      // If scrolled to right and there is more to scroll
      if(container.scrollLeft >= 0) {
        btnSlideLeft.classList.remove("btn-hide");
      }
      // If scrolled to right and max is reached
      if(container.scrollLeft > maxScrollLeft-1) {
        btnSlideRight.classList.add("btn-hide");
      }
      });
    });

    $( ".knockout-slide-left" ).each(function() {
      $(this).on('click', function() {
        var container = document.getElementById('knockout-view');
        var maxScrollLeft = container.scrollWidth - container.clientWidth;
        switch(true) {
        // case firstPosition:
        case (container.scrollLeft === firstPosition):
            break;
          //case  secondPosition:
            case  (container.scrollLeft <= secondPosition):
            {
              container.scrollLeft = firstPosition;
              knockoutComponent.setEighthFinalStage(); 
            break;
            }
          //case  thirdPosition:
          case  (container.scrollLeft > secondPosition && container.scrollLeft <= thirdPosition):
            {
              container.scrollLeft = secondPosition;
              knockoutComponent.setQuarterFinalStage();
            break;
            }
          //case  fourthPosition:
          case  (container.scrollLeft > thirdPosition && container.scrollLeft <= fourthPosition):
            {
              container.scrollLeft = thirdPosition;
              knockoutComponent.setSemiFinalStage();
              break;
            }  

        }
      if( container.scrollLeft === 0){
        btnSlideLeft.classList.add("btn-hide");
      }
       if(container.scrollLeft < maxScrollLeft-1) {
            btnSlideRight.classList.remove("btn-hide");
          }

      });
    });
}

  onPreloadDone() {
    this.isPreloaded = true;
  }
}
